import React from 'react';
import { useGlobalFilter, useTable } from './Table';
import SearchIcon from '../icons/SearchIcon';

function DebouncedInput({
  value: initialValue,
  onChange,
  debounce = 500,
  ...props
}: {
  value: string | number;
  onChange: (_value: string | number) => void;
  debounce?: number;
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'>) {
  const [value, setValue] = React.useState(initialValue);

  React.useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value);
    }, debounce);

    return () => clearTimeout(timeout);
  }, [value]);

  return (
    <div
      className={`md:w-[300px] border-[0.5px] border-solid border-neutral-300 rounded flex items-center py-2 px-3 gap-4 `}
    >
      <SearchIcon className="w-5 h-5 text-neutral-400" />
      <input
        value={value}
        onChange={(e) => setValue(e.target.value)}
        {...props}
      />
    </div>
  );
}

interface TableSearchInputProps
  extends Omit<
    React.InputHTMLAttributes<HTMLInputElement>,
    'onChange' | 'value'
  > {
  manualFilter?: boolean;
  value?: string;
  onChange?: (_value: string | number) => void;
}

export default function TableSearchInput({
  className = '',
  manualFilter = false,
  value,
  onChange,
  ...props
}: TableSearchInputProps) {
  const [globalFilter, setGlobalFilter] = useGlobalFilter();

  const debouncedInputChange = () => {
    if (manualFilter) {
      return onChange;
    }
  };

  return (
    <DebouncedInput
      value={manualFilter ? value : globalFilter}
      onChange={
        manualFilter ? onChange : (_value) => setGlobalFilter(String(_value))
      }
      className={`mt-0 block w-full  focus:ring-0  border-none appearance-none h-6 bg-transparent outline-none focus:outline-none focus:shadow-none  placeholder:text-neutral-400 text-text-black tracking-wider p-0 ${className}`}
      placeholder="Buscar"
      type="search"
      {...props}
    />
  );
}
